import axios from "axios"

import api from "./axios"

/**
 * Client for all authenticated get API requests
 * @param {string} url - full get request URL
 * @returns {Promise<unknown>} - axios request response
 * Note all client responses should be typed as `Promise<unknown>`. APIs are
 * an external resource so it is impossible to be certain of type. Leaving it
 * as above forces developers to provide type guards to defend against
 * unexpected data types.
 */
export const getClientProtected = (url: string): Promise<unknown> =>
    api.get(url).then((res) => res.data)

/**
 * Client for all authenticated get API requests
 * @param {string} url - full get request URL
 * @returns {Promise<unknown>} - axios request response
 * Note all client responses should be typed as `Promise<unknown>`. APIs are
 * an external resource so it is impossible to be certain of type. Leaving it
 * as above forces developers to provide type guards to defend against
 * unexpected data types.
 */
export const postClientProtected = <T extends object>(
    url: string,
    body: T | null
): Promise<unknown> => api.post(url, body).then((res) => res.data)

/**
 * Client for all authenticated get API requests
 * @param {string} url - full get request URL
 * @returns {Promise<unknown>} - axios request response
 * Note all client responses should be typed as `Promise<unknown>`. APIs are
 * an external resource so it is impossible to be certain of type. Leaving it
 * as above forces developers to provide type guards to defend against
 * unexpected data types.
 */
export const postFormDataClientProtected = <T extends FormData>(
    url: string,
    body?: T
): Promise<unknown> =>
    api
        .post(url, body, { headers: { "Content-Type": "multipart/form-data" } })
        .then((res) => res.data)

/**
 * Client for all authenticated get API requests
 * @param {string} url - full get request URL
 * @returns {Promise<unknown>} - axios request response
 * Note all client responses should be typed as `Promise<unknown>`. APIs are
 * an external resource so it is impossible to be certain of type. Leaving it
 * as above forces developers to provide type guards to defend against
 * unexpected data types.
 */
export const patchClientProtected = (
    url: string,
    body: Record<string, unknown> | null
): Promise<unknown> => api.patch(url, body).then((res) => res.data)

/**
 * Client for all authenticated get API requests
 * @param {string} url - full get request URL
 * @returns {Promise<unknown>} - axios request response
 * Note all client responses should be typed as `Promise<unknown>`. APIs are
 * an external resource so it is impossible to be certain of type. Leaving it
 * as above forces developers to provide type guards to defend against
 * unexpected data types.
 */
export const deleteClientProtected = (url: string): Promise<unknown> =>
    api.delete(url).then((res) => res.data)

/**
 * Client for all public GET API requests
 * @param {string} url - full get request URL
 * @returns {Promise<unknown>} - axios request response
 */
export const getClientPublic = (url: string): Promise<unknown> =>
    axios.get(url).then((res) => res.data)

/**
 * Client for all public POST API requests
 * @param {string} url - full post request URL
 * @param {object} body - request body
 * @returns {Promise<unknown>} - axios request response
 * Note all client responses should be typed as `Promise<unknown>`. APIs are
 * an external resource so it is impossible to be certain of type. Leaving it
 * as above forces developers to provide type guards to defend against
 * unexpected data types.
 */
export const postClientPublic = <T extends object>(
    url: string,
    body: T | null
): Promise<unknown> => axios.post(url, body).then((res) => res.data)
